"use strict";
/**
 * Appeal System API Types
 *
 * Types for user appeals of moderation decisions.
 *
 * Derivation:
 * - AppealItem: derived from AppealRecord using Pick for fields that overlap.
 *   The getAppealQueue() and getUserAppeals() handlers return raw DynamoDB items
 *   without sanitization, so resolved_by/resolved_at are included despite being
 *   in InternalFields. We use Pick (not SanitizedRecord) to select exactly the
 *   fields the API exposes, and narrow `status` from `ModerationStatus | string`
 *   to `ModerationStatus`.
 * - Request types remain standalone (Requirement 9).
 */
Object.defineProperty(exports, "__esModule", { value: true });
